G.Leaderboard = {} || G.Leaderboard;

G.Leaderboard.LeaderboardWaitingGroup = function(x, y, config) {
  Phaser.Group.call(this, game);
  this.position.setTo(x, y);

  this.config = Object.assign({
    maxWidth: 200,
    maxHeight: 80,
    errorText: "Error!",
    errorStyle: {
      fontSize: 30,
    },
    messageTimeoutMS: 10000,
  }, config);

  this.spinningIcon = null;
  this.messageTxt = null;
  this.timeEvent = null;

  this.init(this.config);
  this.hide();
};

G.Leaderboard.LeaderboardWaitingGroup.prototype = Object.create(Phaser.Group.prototype);

G.Leaderboard.LeaderboardWaitingGroup.prototype.init = function(config) {
  this.spinningIcon = new G.WaitingIcon(0, 0);
  this.add(this.spinningIcon);

  this.spinningIcon.width = Math.min(config.maxWidth, this.spinningIcon.width);
  this.spinningIcon.height = Math.min(config.maxHeight, this.spinningIcon.height);
  this.spinningIcon.scale.setTo(
    Math.min(
      this.spinningIcon.scale.x,
      this.spinningIcon.scale.y
    )
  );

  this.messageTxt = new G.Text(0, 0, config.errorText,
    config.errorStyle, 0.5, config.maxWidth, config.maxHeight, true, "center");
  this.add(this.messageTxt);
};

G.Leaderboard.LeaderboardWaitingGroup.prototype.show = function() {
  this.spinningIcon.visible = true;
  this.messageTxt.visible = false;
  this.visible = true;

  this.setTimeEvent();
};

G.Leaderboard.LeaderboardWaitingGroup.prototype.hide = function() {
  this.visible = false;
  this.removeTimeEvent();
};

G.Leaderboard.LeaderboardWaitingGroup.prototype.removeTimeEvent = function() {
  if (this.timeEvent) {
    game.time.events.remove(this.timeEvent);
    this.timeEvent = null;
  }
};

G.Leaderboard.LeaderboardWaitingGroup.prototype.setTimeEvent = function() {
  this.removeTimeEvent();
  this.timeEvent = game.time.events.add(this.config.messageTimeoutMS, function() {
    this.spinningIcon.visible = false;
    this.messageTxt.visible = true;
  }, this);
};